export const BOOKING_URL =
  process.env.REACT_APP_BOOKING_URL ||
  "https://www.planity.com/linstitut-de-julie-91430-igny";
